<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'2000'"
          :disabled="node.human"></v-text-field>
      </div>
    </div>

    <v-btn v-if="!showEditor" class="d-flex" text outlined @click="showEditor = true">
      Content Edit
    </v-btn>

    <div v-if="!showEditor">
      <div class="content-preview-label">
        Content preview
      </div>
      <div class="text-left content-preview" v-html="node.content">
      </div>
    </div>

    <va-tinymce-input
      v-if="showEditor"
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.content"
      :editor-height="120"
      live-chat-message-preset
      title="Message"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updateMessageContent(content)" />

    <div class="d-flex align-start">
      <div class="message-item__label">
        {{ $t("shortcodes.live_chat_auto.answer_preview") }}
      </div>
    </div>
    <div class="d-flex align-start">
      <img class="input-question-preview__img" :src="currentImage" />
    </div>
  </div>
</template>

<script>
  import birthYearImg from "@/assets/images/input-question/birthYear.png";
  import enterAgeImg from "@/assets/images/input-question/enterAge.png";
  import birthYearUnderscoreImg from "@/assets/images/input-question/birthYearUnderscore.png";

  export default {
    name: "LiveChatInputQuestion",
    components: {},
    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        currentImage: "",
        showEditor: !this.node?.content,
      };
    },
    mounted() {
      const questionPreviewImages = {
        enter_age: enterAgeImg,
        enter_birth_year: birthYearImg,
        enter_birth_year_underscore: birthYearUnderscoreImg,
      };

      this.currentImage = questionPreviewImages[this.node.inputQuestionType] || null;
    },
    methods: {
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      updateMessageContent(content) {
        // eslint-disable-next-line vue/no-mutating-props
        this.node.content = content;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .input-question-preview__img {
    max-width: 240px;
  }
</style>
